import React from 'react'
import { Link } from 'react-router-dom'
import Sale_1 from '../../../assets/images/sales/01.png'

const Sales = () => {
    return (
        <>
            <section id="sales" className="sales-main-block">
                <div className="sales-shadow-bg-one" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="sales-block">
                                <div className="sales-img">
                                    <Link to="#" className="sale" title="">
                                        <img
                                            src={Sale_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="sales-dtls text-center">
                                <h6 className="sale-sub-heading">Sale Upto 40% Sale</h6>
                                <h2 className="sales-heading">Biggest Sale of the year</h2>
                                <p>
                                    This offer Valid for nov,2025 you can buy our trendy all product
                                </p>
                                <Link to="" title="" className="btn btn-primary-four">
                                    View Categories
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sales-shadow-bg-two" />
            </section>

        </>
    )
}

export default Sales
